import { render, staticRenderFns } from "./SlideTitleSettings.vue?vue&type=template&id=0ce2132f&scoped=true&"
import script from "./SlideTitleSettings.vue?vue&type=script&lang=js&"
export * from "./SlideTitleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2132f",
  null
  
)

export default component.exports